import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
// import 'vant/lib/index.css'
import '@/styles/index.css'
import 'lib-flexible/flexible.js'
import globalMixin from './mixins/global'

import CONSTANTS from './constants'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import vueMiniPlayer from 'vue-mini-player'
import 'vue-mini-player/lib/vue-mini-player.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.prototype.CONSTANTS = CONSTANTS

Vue.config.productionTip = false
// http请求挂载到vue原型上
Vue.use(Vant)
// 全局混入
Vue.mixin(globalMixin)


Vue.use(preview)

Vue.use(vueMiniPlayer)


Vue.use(ElementUI);


new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    // 加载用户登录的数据
    this.$store.dispatch('admin/account/load');
  }
}).$mount('#app')
// 路由跳转新页面时，滚动条回到顶部
router.beforeEach((to, from, next) => {
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari

  window.pageYOffset = 0
  next()
})
